import { render, staticRenderFns } from "./StandaloneReleases.vue?vue&type=template&id=d06204b2&scoped=true&"
import script from "./StandaloneReleases.vue?vue&type=script&lang=js&"
export * from "./StandaloneReleases.vue?vue&type=script&lang=js&"
import style0 from "./StandaloneReleases.vue?vue&type=style&index=0&id=d06204b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06204b2",
  null
  
)

export default component.exports